/**
 * 가입 순간 보고의 클라 창구 — 보관된 광고·메일 유입과 활동 신원을 실어 «기록해 달라»만 한다. 판정·저장은 서버가 정한다.
 *
 * ⛔ **던지지 않는다.** 가입 흐름이 이 호출에 매여선 안 된다.
 */

import { readAdTouch } from 'src/utils/attribution/ad-touch';
import { readOutreachTouch } from 'src/utils/attribution/outreach-touch';
import { readBrowserStorage, readStoredOutreachRef } from 'src/utils/outreach/outreach-ref';

import { fetchIdToken } from 'src/lib/firebase/auth-kit';
import { peekSessionId, getAnonymousId } from 'src/lib/analytics/session';

/** 계정 생성 직후 한 번 — 토큰이 없으면(아직 로그인 전) 조용히 건너뛴다 */
export async function reportSignup(): Promise<void> {
  try {
    // 기다리기 전에 읽는다 — 영업 메일 보고가 성공하면 그 표식을 지운다
    const local = readBrowserStorage('local');
    const body = JSON.stringify({
      adFirst: local ? readAdTouch(local, 'first') : null,
      adLast: local ? readAdTouch(local, 'last') : null,
      outreachFirst: local ? readOutreachTouch(local, 'first') : null,
      outreachLast: local ? readOutreachTouch(local, 'last') : null,
      outreachPending: Boolean(local && readStoredOutreachRef(local)),
      anonymousId: getAnonymousId(),
      sessionId: peekSessionId(),
      path: window.location.pathname,
    });
    const token = await fetchIdToken();
    if (!token) return;
    await fetch('/api/attribution/signup', {
      method: 'POST',
      headers: { 'content-type': 'application/json', Authorization: `Bearer ${token}` },
      body,
      keepalive: true,
    });
  } catch {
    // 가입 기록 실패는 화면에 알리지 않는다
  }
}
